import { render, staticRenderFns } from "./ProductDetailsModal.vue?vue&type=template&id=7aa31cc7&scoped=true"
import script from "./ProductDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductDetailsModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductDetailsModal.vue?vue&type=style&index=0&id=7aa31cc7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa31cc7",
  null
  
)

export default component.exports